import React from 'react'
import PropTypes from 'prop-types'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import { Expansible } from 'components/Expansible'
import BuildCompanyData from 'components/ExpandedInfo/BgcExpansible/BuildCompanyData'

import { COMPANY_RELATED_QUESTIONS } from 'utils/constants/DueDiligenceRelations'
import {
  DisplayActivities,
  DisplayFinancialEntityPosition,
  DisplayInvestmentRobots,
  DisplayProducts,
} from 'components/DueDiligence/Questions'

import styles from './styles'

function BuildCompaniesReviewInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      <Expansible title="Respostas do formulário Due Diligence">
        <div className={classes.questionsList}>
          {reviewData?.related_form_answers?.map((answer) => {
            if (
              answer?.answer_object?.question_name ===
              COMPANY_RELATED_QUESTIONS.FINANCIAL_ACTIVITIES
            ) {
              return (
                <DisplayFinancialEntityPosition
                  key={answer.uuid}
                  questionData={answer?.answer_object}
                />
              )
            }
            if (
              answer?.answer_object?.question_name ===
              COMPANY_RELATED_QUESTIONS.AUTOMATION_ACTIVITIES
            ) {
              return (
                <DisplayInvestmentRobots
                  key={answer.uuid}
                  questionData={answer?.answer_object}
                />
              )
            }
            if (
              answer?.answer_object?.question_name ===
              COMPANY_RELATED_QUESTIONS.ENVIRONMENT_RELATED_ACTIVITIES
            ) {
              return (
                <DisplayActivities
                  key={answer.uuid}
                  questionData={answer?.answer_object}
                />
              )
            }
            if (
              answer?.answer_object?.question_name ===
                COMPANY_RELATED_QUESTIONS.INTERNATIONAL_PRODUCT_ACTIVITIES ||
              answer?.answer_object?.question_name ===
                COMPANY_RELATED_QUESTIONS.NATIONAL_PRODUCT_ACTIVITIES
            ) {
              return (
                <DisplayProducts
                  key={answer.uuid}
                  questionData={answer?.answer_object}
                />
              )
            }
            return null
          })}
        </div>
      </Expansible>
      {reviewData?.extra_questions && (
        <Expansible title="Respostas às questões automáticas relacionadas à pergunta">
          <AutomaticQuestions questions={reviewData?.extra_questions} />
        </Expansible>
      )}

      <Expansible title="Dados do Bureau relacionados ao assessor">
        <BuildCompanyData companyData={reviewData.company_data} />
      </Expansible>
    </div>
  )
}

BuildCompaniesReviewInfo.propTypes = {
  reviewData: PropTypes.shape({
    created: PropTypes.string,
    updated: PropTypes.string,
    uuid: PropTypes.string,
    decisions: PropTypes.arrayOf(
      PropTypes.shape({
        created: PropTypes.string,
        updated: PropTypes.string,
        uuid: PropTypes.string,
        area_decision: PropTypes.string,
        reviewer_id: PropTypes.number,
        reviewer: PropTypes.shape({
          uuid: PropTypes.string,
          email: PropTypes.string,
          display_name: PropTypes.string,
        }),
        reviewer_comment: PropTypes.string,
        current_review_area: PropTypes.string,
      }),
    ),
    result: PropTypes.string,
    current_review_area: PropTypes.string,
    reason: PropTypes.string,
    related_form_answers: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        answer_object: PropTypes.object,
      }),
    ),

    extra_questions: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        text: PropTypes.string,
        occurrence: PropTypes.shape({
          reason: PropTypes.string,
          classification: PropTypes.string,
        }),
        answered: PropTypes.bool,
        subject: PropTypes.string,
      }),
    ),
    type: PropTypes.string,
    company_data: PropTypes.shape({
      uuid: PropTypes.string,
      created: PropTypes.string,
      updated: PropTypes.string,
      has_active_companies: PropTypes.bool,
      has_conflicting_companies: PropTypes.bool,
      status: PropTypes.string,
      companies: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string,
          cnpj: PropTypes.string,
          name: PropTypes.string,
          cadastral_situation: PropTypes.string,
          status: PropTypes.string,
          conflict_classification: PropTypes.string,
          conflicts: PropTypes.array,
          details: PropTypes.object,
        }),
      ),
      conflicting_companies: PropTypes.array,
    }),
  }).isRequired,
}

export default BuildCompaniesReviewInfo
